




























































































import {
  defineComponent,
  computed,
  ComputedRef,
  ref
} from "@vue/composition-api";
import PinFlow from "@/views/PinFlow.vue";
import AddContact from "@/views/AddContact.vue";
import AddNetwork from "@/views/AddNetwork.vue";
import NetworkList from "@/components/NetworkList.vue";
import WalletMenu from "@/components/WalletMenu.vue";
import CurrencyList from "@/components/CurrencyList.vue";
import { useRouter, useRoute } from "@/hooks/use-router";
import { useVuex } from "@/hooks/use-vuex";
import { Network } from "@/models/network";
import { makeid } from "@/lib/makeid";
import { useQr } from "@/hooks/use-qr";

export default defineComponent({
  components: {
    PinFlow,
    AddContact,
    AddNetwork,
    WalletMenu,
    CurrencyList,
    NetworkList
  },
  setup(_, ctx) {
    const router = useRouter();
    const closeModals = () => router.push("?");
    const {
      store: { state, commit, getters, dispatch }
    } = useVuex();
    const route = useRoute();
    const wallet = computed(() => getters.Wallet.wallet);
    const { qr } = useQr();

    const pinDialog = computed({
      get: () => state.Login.pinDialog,
      set: val => commit.Login.setPinDialog(val)
    });

    const openModal = (name: string) => router.push("?modal=" + name);

    const addNetwork = (network: Network) => {
      commit.Wallet.addNetwork({ ...network, id: makeid(20) });
      closeModals();
    };

    const modalNames = [
      "addContact",
      "addNetwork",
      "network",
      "networkList",
      "walletMenu",
      "currency",
      "contacts",
      "walletNetwork",
      "qr"
    ];

    const modals: ComputedRef<{ [key: string]: { value: boolean } }> = computed(
      () =>
        modalNames.reduce(
          (obj, name) => ({
            ...obj,
            ...{
              [name]: computed({
                get: () => ctx.root.$route.query?.modal === name,
                set: value => (value ? openModal(name) : closeModals())
              })
            }
          }),
          {}
        )
    );

    const selectNetwork = async (network: Network) => {
      const address = wallet.value?.address;
      if (!address) return router.push("/portfolio");
      router.push("?");
      commit.Wallet.patchWallet({
        address: wallet.value?.address || "",
        update: {
          network
        }
      });
      await dispatch.Wallet.updateWallet({ address, force: true });
    };

    const onDecode = (value: string) => {
      qr.value = value;
    };

    return {
      pinDialog,
      closeModals,
      route,
      modals,
      openModal,
      addNetwork,
      wallet,
      selectNetwork,
      onDecode,
      qr
    };
  }
});
